import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@/redux/store";
import { selectIsAuthenticated, selectUser } from "@/redux/slices/authSlice";

interface GuestRouteProps {
  children: React.ReactNode;
}

/**
 * GuestRoute - Redirects authenticated users away from public pages (login/register)
 * Simple and fast - just checks Redux state (no API calls)
 * AuthProvider handles all authentication initialization
 */
export default function GuestRoute({ children }: GuestRouteProps) {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const user = useAppSelector(selectUser);

  // Redirect authenticated users away from login/register
  if (isAuthenticated) {
    if (user?.needsCompanySetup) {
      return <Navigate to="/onboarding" replace />;
    }
    const from = (location.state as { from?: { pathname?: string } })?.from?.pathname || "/";
    return <Navigate to={from} replace />;
  }

  // Allow access if not authenticated
  return <>{children}</>;
}
